import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Map } from 'immutable';
import connect from '../store/connect';
import { FullWidthContainer } from '../styles/FullWidthContainer';
import { Quote } from '../styles/Quote';
import { Container } from '../styles/Container';
import { size } from '../styles/helpers/variables';

const BlockquoteWithImages = props => (
  <BlockquoteWithImagesContainer paddedBottom={props.paddedBottom}>
    {props.viewstate.get('pageWidth') < size.medium ? (
      <Container noPadding>
        <ArticleImageAsImg src={props.leftImage} />
        <ArticleImageAsImg src={props.rightImage} />
      </Container>
    ) : (
      <Container noPadding>
        <ImageContainer>
          <ArticleImageContainer>
            <ArticleImage url={props.leftImage} />
          </ArticleImageContainer>
          <ArticleImageContainer>
            <ArticleImage square url={props.rightImage} />
          </ArticleImageContainer>
        </ImageContainer>
      </Container>
    )}
    <ArticleContainer noPadding>
      <BlockQoute>{props.quote}</BlockQoute>
    </ArticleContainer>
  </BlockquoteWithImagesContainer>
);

const BlockquoteWithImagesContainer = FullWidthContainer.extend`
  margin-top: 40px;
  margin-bottom: 40px;

  @media screen and (min-width: ${size.medium}px) {
    margin-top: 80px;
    margin-bottom: 60px;
  }
  ${props =>
    props.paddedBottom &&
    css`
      margin-bottom: 0 !important;
      padding-bottom: 40px;
      @media screen and (min-width: ${size.medium}px) {
        padding-bottom: 60px;
      }
    `};
`;

const ArticleContainer = Container.extend`
  @media screen and (min-width: ${size.large}px) {
    width: 820px;
  }
`;

const ArticleImageAsImg = styled.img`
  max-width: 100%;
  height: auto;
  margin: 10px 0;
`;

const ImageContainer = styled.div`
  display: flex;
  max-width: 100%;
  align-items: stretch;
  justify-content: space-between;
`;

const ArticleImageContainer = styled.div`
  height: auto;
  flex: 5;

  &:last-of-type {
    flex: 3;
    margin-left: 26px;
  }
`;

const ArticleImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("${props => props.url}");
  background-size: cover;
  background-position: center;

  ${props =>
    props.square &&
    css`
      height: 0;
      padding-bottom: 100%;
    `};
`;

const BlockQoute = Quote.extend`
  margin-bottom: 0;
`;

BlockquoteWithImages.defaultProps = {
  leftImage: null,
  rightImage: null,
  viewstate: Map(),
  paddedBottom: false
};

BlockquoteWithImages.propTypes = {
  quote: PropTypes.string.isRequired,
  leftImage: PropTypes.string,
  rightImage: PropTypes.string,
  viewstate: PropTypes.instanceOf(Map),
  paddedBottom: PropTypes.bool
};

export default connect(BlockquoteWithImages, {}, store => ({
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/BlockquoteWithImages.js